
import { lazy } from 'react';

export const LazySettings = lazy(() => 
  import('@/pages/Settings').then(module => ({ default: module.Settings }))
);
